import * as ChangePasswordTypes from 'src/actions/user/changePassword/Types';
import { ChangePasswordAction } from 'src/actions/user/changePassword/ChangePassword.actions';

export interface ChangePasswordState {
    loading: boolean;
    error: boolean;
    errorMessage: {};
}

const initialState: ChangePasswordState = {
    loading: false,
    error: false,
    errorMessage: {},
};

export function ChangePasswordReducer(state: ChangePasswordState = initialState,
                                      action: ChangePasswordAction): ChangePasswordState {
    switch (action.type) {
        case ChangePasswordTypes.CHANGE_PASSWORD_ATTEMPT:
            return {...state, loading: true, error: false};
        case ChangePasswordTypes.CHANGE_PASSWORD_SUCCESS:
            return {...state, loading: false, error: false};
        case ChangePasswordTypes.CHANGE_PASSWORD_FAILURE:
            return {...state, loading: false, error: true, errorMessage: action.payload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user/ChangePasswordReducer.tsx